import styled from 'styled-components/macro';
import { SearchInput } from '@yme/atoms/filters-elements';
import { Row } from '@yme/atoms/grid';
import { MiniButton } from '@yme/atoms/mini-button';
import { colorCoreBlack900Base, colorCoreGray500 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
import { boxStyled } from '../ComparisonFilter/components/FilterResults/styled';
export const ResultItemsCounterStyled = styled.span `
  color: ${colorCoreBlack900Base};

  display: flex;
  gap: 4px;
  padding: 12px 0;
  flex-grow: 0;
  white-space: nowrap;

  ${getTextStyles('Ubuntu', 400, 14, 18)}
`;
export const RowStyled = styled(Row) `
  margin-bottom: 24px;
`;
export const FlexWrapperStyled = styled(FlexWrapper) `
  ${({ isBorderShown }) => isBorderShown && `box-shadow: inset 0px -1px 0px ${colorCoreGray500};`}
`;
export const FilterWrapperStyled = styled(FlexWrapper) `
  & > div {
    &:first-child {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }

    & > *:last-child {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
`;
export const SearchInputStyled = styled(SearchInput) `
  input {
    margin-top: 1px;
    line-height: 18px;
  }
`;
export const SortOrderStyled = styled.div `
  flex-grow: 1;
  max-width: 100%;

  ${ADAPTIVE.minWidth.desktop} {
    width: 230px;
  }
`;
export const FiltersListStyled = styled.ul `
  margin: 0;
  padding: 0;
`;
export const FiltersButtonStyled = styled(MiniButton) `
  ${boxStyled}
`;
